import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import '../../styles/Icons/ExternalLinkIcon.scss'

const ExternalLinkIcon = () => {
  return <FontAwesomeIcon icon={faExternalLinkAlt} className="external_link_icon"/>
}

export default ExternalLinkIcon
